<script>

import Footer from "@/components/Footer";
  export default {
    components: {
        Footer
    },
    data() {
        return {
        isSticky: false,
        stickyClass: 'is_sticky',
        scrollPosition:0,
        }

    },
    created () {
        try {
          this.checked=localStorage.getItem("mode")==='false'? true: false;
        } catch(e) {
          this.checked=false;
        }
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll);
    },  
    methods:{
        handleScroll(){
        this.scrollPosition = window.scrollY
        if(this.scrollPosition>=50){
            this.isSticky=true
        }else{
            this.isSticky=false
        }
        },
    }
}
</script>

<style scoped>

.navbar-custom {
  font-size: 2rem;
  font-weight: 700;
  background:#fff;
  box-shadow: 0 0 21px rgb(0 0 0 / 20%);
  position: relative;
  z-index: 9;
  padding: 10px;
}
.navbar-custom.isSticky {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
  width: 100%;
  /* width: calc(100% - 320px); */
   -webkit-transition: all 0.4s ease;
  transition: all 0.4s ease;

}
.darkmode .navbar-custom.isSticky{
  background-color: #180f4f !important;
  border-color: #180f4f !important;
  top: -24px;
  transform: translateY(24px);
  transition: transform .4s;
}
.darkmode .navbar-custom, 
.darkmode .navbar-light, 
.darkmode .navbar{
  background:#1E2041!important;
}
.darkmode .navbar-custom .light-logo, 
.darkmode .navbar-light .light-logo, 
.darkmode .navbar .light-logo, .dark-logo{
  display: none;
}
.darkmode .navbar-custom .dark-logo, 
.darkmode .navbar-light .dark-logo, 
.darkmode .navbar .dark-logo{
  display: block;
}

.navbar-logo a img{
  max-height: 60px;
}

.post-categories a{
    color: rgba(65,201,201,1)!important;
    font-size: 14px;
    margin-bottom: 10px;
}

.post-meta-content {
    display: flex;
    align-items: center;
    margin-top: 10px;
}
/* .post-auhor-date.post-auhor-date-full {
    display: inherit;
} */
.post-meta-content a, .post-meta-content span{
    /* display: inline-flex; */
    font-size: 12px;
    margin-right: 10px;
    color: #222;
} 
.post-meta-content .avatar
{
    border-radius: 100px;
}
.post-categories-container a h4{
    font-size: 20px;
    margin-top: 0px;
    margin-bottom: 14px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;  
    overflow: hidden;
}
.post-style-cover{
    -ms-flex: 0 0 50%;
    -webkit-box-flex: 0;
    flex: 0 0 50%;
    max-width: 50%;
}
.darkmode .post-categories a {
    color: rgba(65,201,201,1)!important;
}
.darkmode .post-meta-content a{
    color: rgb(179, 180, 180)!important;
}

.post-style-cover .post-categories-container a h4{
    font-size: 28px;
}
.post-style-cover .post-categories-container a h4,
.post-style-cover .post-meta-content a{
    color: #fff;
}


.post-title{
    color: #222;
}
.darkmode .post-title{
    color: #d5d5d5;
}
.wp-block-quote p{
    font-size: 20px;
    color: #000;
    font-weight: 600;
}
.darkmode .wp-block-quote p{
    color: #fff;
}
.darkmode .wp-block-quote.bg-light{
    background-color: #180f4f !important;
}

@media screen and (max-width: 768px) {   
    h1, .h1 {
        font-size: 1.6rem;
    }
}
</style>

<template>

<div class="darkmode">

<div class="navbar-custom" :class="{'isSticky':isSticky}" toggleable="lg" id="#navbar">
    <b-container>
        <b-row class="align-items-center">
            <b-col sm="12" md="4" class="text-center text-lg-left">  
                <router-link to="/"  class="btn btn-secondary btn-sm mr-2">
                    <i class="fas fa-angle-left"></i>
                    Home
               </router-link>
                <router-link to="/blog-listing"  class="btn btn-secondary btn-sm">
                    <i class="fas fa-angle-left"></i>
                    Blog Listing
               </router-link>
               <!--<b-button @click="$parent.changePage('main')"  class="btn btn-secondary btn-sm">
                    <i class="fas fa-angle-left"></i>
                    Back to Home
               </b-button> -->
            </b-col>
            <b-col sm="12" md="4">
            <div class="navbar-logo customer-logo text-center my-2 my-md-0">
                  <a class="d-inline-block" href="https://spendid.io">
                     <img alt="logo" src="logov.png" class="light-logo" />
                    <img alt="logo" src="logo-darkv.png" class="dark-logo"/> 
                  </a>
              </div>
            </b-col>
            <b-col sm="12" md="4"></b-col>
        </b-row>
    </b-container>
</div>

<b-container class="py-2 py-md-4">
    <!-- <b-row>
        <b-col md="12" xl="12">
            <div class="blog-heading d-flex align-items-center">
                <b-button variant="info" size="sm" class="mr-3"> Trending Articles</b-button>
                <h4 class="mb-0">Different Heaven – Safe And Sound</h4>
            </div>
        </b-col>
    </b-row> -->
    
     <b-row>
        <b-col md="12" class="col-lg-8 offset-lg-2" >
            <div class="post-thumbnail mb-4">
                <b-img alt="thumbnail" src="0006_1-1024x683.jpg"></b-img>
            </div>
            <div class="post-single-meta">
                <div class="post-categories-container pb-0">
                    <div class="post-categories">
                        <a href="">Lifestyle</a>
                    </div>
                     <a class="post-title"><h1> Top Ten Gadgets of 2021 </h1> </a>
                </div>
            </div>
            <div class="post-meta">
                <div class="post-meta-content"> 
                    <div class="post-auhor-date post-auhor-date-full mr-2">
                        <router-link to=""> 
                            <img alt="avatar" src="avatar.png"
                            class="avatar avatar-28 photo post-author-image" height="28" width="28"> 
                        </router-link>
                        <router-link to="" class="post-author">
                            John Doe
                        </router-link>
                        <router-link to="" class="post-date"> 4 Years ago </router-link> 
                        <router-link to="" class="post-readtime"><i class="fas fa-clock mr-1"></i> 2 min read </router-link>
                    </div> 
                </div>
            </div>
            <div class="post-content post-single-content text-secondary mt-4">
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam laoreet, nunc et accumsan cursus, neque eros sodales lectus, in fermentum libero dui eu lacus. Nam lobortis facilisis sapien non aliquet. Aenean ligula urna, vehicula placerat sodales vel, tempor et orci. Donec molestie metus a sagittis condimentum. Duis vulputate lectus massa, vel viverra sem interdum sit amet. In pulvinar arcu id nisi eleifend, in placerat velit tempor. Sed volutpat orci nec velit cursus posuere. Nulla congue mi sed enim venenatis, eu suscipit neque dictum. Integer nec eros nibh.</p>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam laoreet, nunc et accumsan cursus, neque eros sodales lectus, in fermentum libero dui eu lacus. Nam lobortis facilisis sapien non aliquet. Aenean ligula urna, vehicula placerat sodales vel, tempor et orci. Donec molestie metus a sagittis condimentum. Duis vulputate lectus massa, vel viverra sem interdum sit amet. In pulvinar arcu id nisi eleifend, in placerat velit tempor. Sed volutpat orci nec velit cursus posuere. Nulla congue mi sed enim venenatis, eu suscipit neque dictum. Integer nec eros nibh.</p>
                <blockquote class="wp-block-quote bg-light p-2 p-lg-4">
                <p class="mb-0">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s. Lorem Ipsum is simply.</p></blockquote>
                <p> Equidem impedit officiis quo te. Illud partem sententiae mel eu, euripidis urbanitas et sit. Mediocrem reprimique an vim, veniam tibique omittantur duo ut, agam graeci in vim. Quot appetere patrioque te mea, animal aliquip te pri. Ad vis animal ceteros percipitur, eos tollit civibus percipitur no. Posse definiebas dissentiunt mel ea, nam ferri utroque invenire an. Ius te iuvaret offendit pertinax, his verear deseruisse ex. Illud elitr eam eu. Id usu putant commune, stet primis expetenda cu vel. Mea ipsum homero apeirian te. Accumsan similique instructior ad pro, te purto dicit qui. Qui ex putent suavitate adolescens, his possim tamquam fuisset. </p>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam laoreet, nunc et accumsan cursus, neque eros sodales lectus, in fermentum libero dui eu lacus. Nam lobortis facilisis sapien non aliquet. Aenean ligula urna, vehicula placerat sodales vel, tempor et orci. Donec molestie metus a sagittis condimentum. Duis vulputate lectus massa, vel viverra sem interdum sit amet. In pulvinar arcu id nisi eleifend, in placerat velit tempor. Sed volutpat orci nec velit cursus posuere. Nulla congue mi sed enim venenatis, eu suscipit neque dictum. Integer nec eros nibh.</p>
            </div>
        </b-col>
     </b-row>
</b-container>

<Footer />

</div>   

</template>

